/**
 * @typedef {Object} JobWithPins
 * @prop {Object} pins
 * @prop {number} pins.creatorAmount
 * @prop {number} pins.postAmount
 *
 * @prop {number} pins.subtopicAmount
 * @prop {number} pins.topicAmount
 * @prop {number} pins.savedSearchesAmount
 *
 * @prop {number} pins.territoriesAmount
 *
 * @prop {number} pins.totalPins
 */

class JobUtils {
  #LIMIT_PINS_DEFAULT = 250

  sumPinsAmount(pins) {
    return Number(pins?.creatorAmount + pins?.postAmount + pins?.territoriesAmount) || 0
  }

  /** @param {JobWithPins} job */
  getPinsAmountByTypes(job) {
    const creators = job?.pins?.creatorAmount ?? 0
    const posts = job?.pins?.postAmount ?? 0
    const subtopics = job?.pins?.subtopicAmount ?? 0
    const topics = job?.pins?.topicAmount ?? 0
    const savedPostSearches = job?.pins?.savedSearchesAmount ?? 0
    const territories = subtopics + topics + savedPostSearches

    const amount = {
      creators,
      posts,
      subtopics,
      topics,
      savedPostSearches,
      territories,
      totalAmount: Number(job?.pins?.totalPins) || this.sumPinsAmount(job?.pins),
    }

    return amount
  }

  isFull(job, plan) {
    const totalPinsAmount = this.sumPinsAmount(job?.pins)
    const limitPins = plan.jobPins ?? this.#LIMIT_PINS_DEFAULT

    return totalPinsAmount >= limitPins
  }

  isAlmostFull(job, plan) {
    const percentageRange = 90
    const limitPins = plan?.jobPins ?? this.#LIMIT_PINS_DEFAULT
    const limitPinsRange = (limitPins / 100) * percentageRange
    const totalPinsAmount = this.sumPinsAmount(job?.pins)

    return totalPinsAmount >= limitPinsRange && totalPinsAmount < limitPins
  }
}

const jobUtils = new JobUtils()

/** @returns {JobWithFolders} */
const formatJobForFolderList = job => {
  const folders =
    job.foldersPaginated?.data?.map(({ id, name, pins: folderPins }) => ({
      id,
      name: name,
      jobId: job.id,
      pins: {
        ...folderPins,
        totalAmount: Number(folderPins?.totalPins) || jobUtils.sumPinsAmount(folderPins),
      },
    })) ?? []

  return {
    id: job.id,
    createdAt: job.createdAt,
    folders,
    totalFolders: job.foldersPaginated?.totalCount ?? 0,
    name: job.name,
    ownerName: job.ownerName,
    updatedAt: job.updatedAt,
    pins: {
      ...job.pins,
      totalAmount: Number(job?.pins?.totalPins) || jobUtils.sumPinsAmount(job.pins),
    },
    isAutomaticallyGenerated: job.isAutomaticallyGenerated ?? false,
  }
}

export { jobUtils, formatJobForFolderList }
